(ns machtfit.stepchall.header
  (:require [goog.string :as gstring]
            [machtfit.app.routes :as routes]
            [machtfit.stepchall.help :as help]
            [machtfit.stepchall.icons :as icons]
            [machtfit.translation :refer [tr trn t]]
            [re-frame.core :as rf]))

(defn- header-element [{:keys [is-spectator? team-member-count team-color team-name hidden? absolute?]}]
  [:header.sc_header.sc_vertical-center.sc_justify-space {:style (cond
                                                                   absolute? {:position "absolute"
                                                                              :left "0"
                                                                              :top "0"}
                                                                   hidden? {:visibility "hidden"})}
   (if is-spectator?
     [:div.sc_header-spectator
      [:i.sc_icon [icons/eye]] (tr "Du bist Zuschauer")]
     [:a.sc_header-left.sc_vertical-center (routes/attrs-link-to-page {:id :stepchall
                                                                       :subpage :my-team
                                                                       :show-members? true})
      [:div.sc_header-team-color {:style {:background-color team-color}}]
      [:div.sc_header-team
       [:span (t team-name)]
       [:span.sc_header-team-count.sc_light (gstring/format (trn "%d Mitglied" "%d Mitglieder" team-member-count) team-member-count)]]])
   [help/help {:text (tr "Hilfe")}]])

(defn header []
  (let [team @(rf/subscribe [:get [:stepchall :team]])
        header-args {:is-spectator? (nil? team)
                     :team-name (:name team)
                     :team-member-count (:member-count team)
                     :team-color (:color team)}]
    [:<>
     [header-element (assoc header-args :hidden? true)]
     [header-element (assoc header-args :absolute? true)]]))
